import { mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { Box, Button, Dialog, Stack, Tooltip, Typography } from "@mui/material";
import React from "react";

function TemplateErrorPreviewDialog({ onClose, open, data, name = null, type = null }) {
    let jsonData = [];

    try {
        jsonData = typeof data === "string" ? JSON.parse(data) : data;
    } catch (error) {
        onClose()
        return null;
    }

    const errorCode = jsonData?.code || '';
    const errorMessage = jsonData?.message || '';
    const errorDescription = jsonData?.description || '';

    return (
        <>
            <Dialog onClose={onClose} open={open}>
                <div className="dialog-title">
                    <h2>Reason for {name ? name : "Template"} Rejection</h2>
                    <Tooltip title="Close">
                        <button className="icon-button dialog-close" onClick={onClose}>
                            <Icon path={mdiClose} color={'currentColor'} size={1} />
                        </button>
                    </Tooltip>
                </div>
                <Box sx={{ padding: 2, borderRadius: '16px' }} className="mb-24 bordered bg-weak">
                    {errorCode &&
                        <>
                            <Typography variant="body-large-bold" component={'p'}>Code</Typography>
                            <Typography variant="body-large" component={'p'}>{errorCode}</Typography>
                            <br />
                        </>
                    }
                    {errorMessage &&
                        <>
                            <Typography variant="body-large-bold" component={'p'}>Error</Typography>
                            <Typography variant="body-large" component={'p'}>{errorMessage}</Typography>
                            <br />
                        </>
                    }
                    {errorDescription &&
                        <>
                            <Typography variant="body-large-bold" component={'p'}>Error Description</Typography>
                            <Typography variant="body-large" component={'p'}>{errorDescription}</Typography>
                            <br />
                        </>
                    }
                </Box>
                <Stack direction={"row"} justifyContent={"flex-end"}>
                    <Button onClick={onClose} color="secondary">Close</Button>
                </Stack>
            </Dialog>
        </>
    );
}

export default TemplateErrorPreviewDialog;